module.exports = __webpack_public_path__ + "static/media/an_ting_deng.4f71172b.jpg";